


















































































































































































import {Component, Vue} from "vue-property-decorator";
import Gallery from "@/components/Gallery.vue";
import {CutPrices} from "@/constants/cutPrices";

declare let require: any;

@Component({
  components: {Gallery},
  props: {
    cutOneImage: {
      type: String,
      default: require("@/assets/images/cutNumbers/1.png")
    },
    cutTwoImage: {
      type: String,
      default: require("@/assets/images/cutNumbers/2.png")
    },
    cutThreeImage: {
      type: String,
      default: require("@/assets/images/cutNumbers/3.png")
    },
    cutFourImage: {
      type: String,
      default: require("@/assets/images/cutNumbers/4.png")
    },
    cutFiveImage: {
      type: String,
      default: require("@/assets/images/cutNumbers/5.png")
    },
    homeImage: {
      type: String,
      default: require("@/assets/images/gemerbarbier_homeBackground.jpg")
    },
    homeMobileImage: {
      type: String,
      default: require("@/assets/images/gemerbarbier_homeBackground_phone.jpg")
    },
    priceListImage: {
      type: String,
      default: require("@/assets/images/gemerbarbier_priceList.jpg")
    },
    priceListMobileImage: {
      type: String,
      default: require("@/assets/images/gemerbarbier_priceList_phone.jpg")
    },
    instagramIcon: {
      type: String,
      default: require("@/assets/images/instagramIcon.png")
    },
    beardImage: {
      type: String,
      default: require("@/assets/images/barbershop.jpg")
    },
    cutImage: {
      type: String,
      default: require("@/assets/images/barbershop.jpg")
    },
    center: {
      type: Object,
      default: () => ({lat: 48.684073, lng: 20.1217573})
    },
    mapTypeId: {
      type: String,
      default: "terrain"
    },
    markers: {
      type: Array,
      default: () => [{position: {lat: 48.684073, lng: 20.1217573}}]
    },
    basicCutPrice: {
      type: String,
      default: CutPrices.BASIC_CUT
    },
    beardPrice: {
      type: String,
      default: CutPrices.BEARD
    },
    exclusiveCutPrice: {
      type: String,
      default: CutPrices.EXCLUSIVE_CUT
    },
    basicBeardPrice: {
      type: String,
      default: CutPrices.BASIC_BEARD
    },
    exclusiveBeardPrice: {
      type: String,
      default: CutPrices.EXCLUSIVE_BEARD
    }
  }
})
export default class HomePage extends Vue {
  jumptToReservation() {
    const routeData = this.$router.resolve({name: "reservation"});
    window.open(routeData.href, "_blank");
  }

  get buttonSize() {
    const size = {xs: "medium", sm: "medium", lg: "large", xl: "large"}[
        this.$vuetify.breakpoint.name
        ];
    return size ? {[size]: true} : {};
  }

  get sectionHeight() {
    return window.innerHeight - 80;
  }

  goToInstagram() {
    window.location.href = "http://instagram.com/gemerbarbier/";
  }
}
